import HomePage from './pages/HomePage';
import Application from './Application';
import PageNotFound from './components/PageNotFound';
import applyMiddleware from './utils/route/applyMiddleware';
import requireLogin from './utils/route/requireLogin';
import refreshAuthentication from './utils/route/refreshAuthentication';
import objectAssign from 'object-assign';
import loadSubscription from './utils/route/loadSubscription';
import requireSubscription from './utils/route/requireSubscription';
import Settings from './utils/Settings';

/**
 * Routes
 */
import Account from './apps/Account';
import Analytics from './apps/Analytics';
import Audit from './apps/Audit';
import Bank from './apps/Bank';
import Billing from './apps/Billing';
import Compliance from './apps/Compliance';
import UserManagement from './apps/UserManagement';

const _routes = [
  {
    path: '/',
    component: Application,
    name: 'root',
    indexRoute: {
      name: 'index',
      component: HomePage,
      onEnter: applyMiddleware(requireLogin, loadSubscription)
    },
    onEnter: applyMiddleware(refreshAuthentication),
    childRoutes: [
      {
        name: 'protected',
        onEnter: applyMiddleware(requireLogin, loadSubscription),
        childRoutes: [
          {
            name: 'requiresSubscription',
            onEnter: applyMiddleware(requireSubscription),
            childRoutes: [
              Analytics,
              Bank,
              Compliance
            ]
          },
          Audit,
          UserManagement,
          Settings.envFeatures.get('bigBank') ? {} : Billing
        ]
      },
      Account,
      {
        path: '*',
        component: PageNotFound,
        name: '404'
      }
    ]
  }
];

function decorateArray(routes, key, value, valueMergerBiFunction) {
  const newArray = [];
  routes.forEach(r => {
    newArray.push(decorate(r, key, value, valueMergerBiFunction));
  });
  return newArray;
}

function decorate(route, key, value, valueMergerBiFunction = (newValue /*, oldValue */) => newValue) {
  const toAssign = {};
  const oldValue = route[key];
  toAssign[key] = valueMergerBiFunction(value, oldValue);
  const newRoute = objectAssign(
    {},
    route,
    toAssign
  );
  if (route.indexRoute) {
    newRoute.indexRoute = decorate(route.indexRoute, key, value, valueMergerBiFunction);
  }
  if (route.childRoutes) {
    newRoute.childRoutes = decorateArray(route.childRoutes, key, value, valueMergerBiFunction);
  }
  return newRoute;
}

class RouteFactory {

  underlying = _routes;

  create = () => this.underlying;

  decoratedWith = (key, value, valueMergerBiFunction) => {
    this.underlying = decorateArray(this.underlying, key, value, valueMergerBiFunction);
    return this;
  }

}

export default RouteFactory;



// WEBPACK FOOTER //
// ./src/RouteFactory.js